export class ChoosePlanDuplicatedContract {
    
	disabledManutencao = false;
	disabledExtensao = false;
	disabledReparo = false;
	
  	constructor() {
	}
}